module.exports = __webpack_public_path__ + "static/media/exide-enhanced-flooded-battery.f4facd97.svg";